module.exports = __webpack_public_path__ + "img/podium.065925c6.png";